export const SHARED_IGNORE_ERRORS: (string | RegExp)[] = [
  "The client is not authorized to perform the action.",
  "The client is not authorized to perform the action. The `code`, `message`, and `data` fields may provide more information about the reason of the error.",
  "User has no rights to perform this operation.",
  "The requested entity was not found, or the client has no permission to access the entity.",
  "Failed to fetch",
  "Load failed",
  "ResizeObserver loop limit exceeded",
  "ResizeObserver loop completed with undelivered notifications.",
  // Queued-request rejection on failed token refresh. Handled at source since
  // FEWEB-2699; kept to silence builds that predate the fix.
  "Authentication failed - token refresh unsuccessful",
  /^Request to https:\/\/api.[a-zA-Z-.]*.9am.health(.*) failed with status code 401$/,
  /^Request to https:\/\/api.[a-zA-Z-.]*.join9am.com(.*) failed with status code 401$/
];
